import { reactive } from 'vue';
import { Options } from 'vue-class-component';

import config from '@/config/config';
import PageBaseList from '@/pages/PageBaseList';
import TableLite from '@/components/table/TableLiteTs.vue';
import * as CarGroupService from '@/services/car-group.service';
import { IPaginateVueTable } from '@/interfaces/IPaginateVueTable';
import { ICarGroup } from '@/domain/car-group.model';

@Options({
  name: 'car-group-list',
  components: {
    TableLite,
  },
})
export default class CarGroupList extends PageBaseList {
  public table = TABLE;

  public mounted(): void {
    this.url = 'car-group';
    this.module = config.modules.carGroup;
    this.table.rows = [];

    this.doSearch(0, this.per_page, 'id', 'asc');
  }

  public doSearch(
    offset?: number,
    limit?: number,
    order?: string,
    sort?: string,
    filter?: string,
  ) {
    this.table.isLoading = true;

    this.table.isReSearch = offset == undefined ? true : false;
    if (offset >= 10 || limit >= this.per_page) {
      limit = this.per_page;
    }

    CarGroupService.list(offset, limit, order, sort, filter).then((res: IPaginateVueTable<ICarGroup>) => {
      this.table.rows = res?.data;
      this.table.totalRecordCount = res?.total;
      this.table.sortable.order = order;
      this.table.sortable.sort = sort;
    });
  }
}

export const TABLE = reactive({
  isLoading: false,
  isReSearch: false,
  columns: [
    {
      label: 'Id',
      field: 'id',
      sortable: true,
      isKey: true,
    },
    {
      label: 'Praça',
      field: 'city_description',
      sortable: true,
      columnStyles: 'text-align: left',
    },
    {
      label: 'Nome',
      field: 'name',
      sortable: true,
      columnStyles: 'text-align: left',
    },
    {
      label: 'Descrição',
      field: 'description',
      sortable: true,
      columnStyles: 'text-align: left',
    },
    {
      label: 'Número de Carros',
      field: 'total_cars',
      sortable: true,
      columnStyles: 'text-align: left',
    },
    {
      label: 'Situação',
      field: 'enabled',
      sortable: true,
    },
    {
      field: 'actions',
    },
  ],
  rows: [{}],
  totalRecordCount: 0,
  sortable: {
    order: 'id',
    sort: 'asc',
  },
});
